module.exports = __webpack_public_path__ + "media/images/features/modification/eyecatch-point-1-aa87359698f038ef5441dc9c0b904b56.svg";